var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLts4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 86,
    viewBox: "0 0 107 86",
    fill: "none",
    id: "svg34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_6462)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.3061 71.0169C87.3061 58.061 79.5524 46.916 68.4322 41.9692M19.0615 71.0169C19.0615 58.061 26.8152 46.916 37.9354 41.9692",
    stroke: "#522B2A",
    strokeWidth: 2.4483,
    id: "path1",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9766 85.5353V75.6705C56.9766 75.3445 56.7124 75.0802 56.3864 75.0802H55.8608C55.5348 75.0802 55.2705 74.8159 55.2705 74.49V70.866C55.2705 70.6918 55.3475 70.5265 55.4807 70.4144L56.8311 69.2781C56.9779 69.1545 57.0555 68.9673 57.0391 68.7761L56.4951 62.4241C56.4777 62.2201 56.3558 62.0398 56.1731 61.9475L55.0969 61.4042C55.0144 61.3625 54.9233 61.3408 54.8308 61.3408H52.9885H51.1594C51.0833 61.3408 51.0079 61.3592 50.9372 61.3948L49.8825 61.9274C49.677 62.0311 49.5337 62.2696 49.5099 62.5473L48.9893 68.6256C48.9654 68.9055 49.0667 69.1789 49.2523 69.3351L50.4787 70.3671C50.6451 70.5072 50.7451 70.7429 50.7451 70.9954V74.692C50.7451 75.018 50.4808 75.2823 50.1548 75.2823H49.4159C49.0899 75.2823 48.8257 75.5465 48.8257 75.8725V85.5353",
    stroke: "#522B2A",
    strokeWidth: 1.77074,
    id: "path2",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.116 40.0834V43.3565C69.116 43.574 69.3198 43.7366 69.5371 43.7465C71.1294 43.8187 73.281 45.9689 70.8707 48.7098C69.42 50.3593 67.5369 49.0618 67.186 48.8858C64.557 54.5193 62.7994 58.5684 53.3245 58.5684C43.8496 58.5684 42.0921 54.5193 39.4631 48.8858C39.1122 49.0618 36.878 50.0966 35.4274 48.447C33.0136 45.7022 35.4702 43.5537 37.1122 43.4882C37.3295 43.4795 37.533 43.316 37.533 43.0985V40.0834C37.7669 38.9685 41.2528 40.0834 53.3245 40.0834C65.3963 40.0834 68.8821 38.9685 69.116 40.0834Z",
    fill: "#F8F8F8",
    id: "path3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.7966 43.8624C36.212 43.5121 33.0428 45.784 35.6838 48.7611C37.1394 50.402 39.0291 49.1114 39.3812 48.9363C42.0193 54.5403 43.7829 58.5682 53.2905 58.5682C62.7981 58.5682 64.5617 54.5403 67.1998 48.9363C67.5519 49.1114 69.4416 50.402 70.8972 48.7611C73.5382 45.784 70.369 43.5121 68.7844 43.8624M76.0032 33.175C76.0032 20.6982 65.8344 10.5837 53.2905 10.5837C40.7467 10.5837 30.5779 20.6982 30.5779 33.175C30.5779 34.3334 30.6655 35.4714 30.8346 36.5828C31.0723 38.1452 31.9599 39.5151 33.1452 40.5671L36.8579 43.8624C37.0849 44.0638 37.4445 43.9036 37.4445 43.601V40.18C37.6792 39.0709 41.1771 40.18 53.2905 40.18C65.4039 40.18 68.9018 39.0709 69.1365 40.18V43.627C69.1365 43.9201 69.4828 44.0757 69.702 43.8812L73.4909 40.5183C74.6402 39.4982 75.5006 38.1675 75.7363 36.6489C75.912 35.5165 76.0032 34.3563 76.0032 33.175Z",
    stroke: "#522B2A",
    strokeWidth: 2.03903,
    id: "path4",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1366 44.3832V40.6067M36.8579 43.8625C37.0849 44.064 37.4445 43.9037 37.4445 43.6012V40.6067M37.7967 43.8625C36.2121 43.5123 33.0429 45.7842 35.6839 48.7613C37.1395 50.4022 39.0291 49.1116 39.3813 48.9364C42.0194 54.5405 43.7829 58.5684 53.2906 58.5684C62.7982 58.5684 64.5618 54.5405 67.1999 48.9364C67.552 49.1116 69.4416 50.4022 70.8973 48.7613C73.5383 45.7842 70.3691 43.5123 68.7845 43.8625",
    stroke: "#522B2A",
    strokeWidth: 2.03903,
    id: "path5",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2554 35.749C39.8866 35.9472 44.1297 36.1755 53.2905 36.1755C62.4513 36.1755 66.6944 35.9472 68.3256 35.749",
    stroke: "#522B2A",
    strokeWidth: 2.03903,
    strokeLinecap: "round",
    id: "path6",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8379 10.3706L51.9609 30.2273C52.0008 30.9324 52.5842 31.4838 53.2904 31.4838V31.4838C53.9966 31.4838 54.58 30.9324 54.6199 30.2274L55.743 10.3706",
    stroke: "#522B2A",
    strokeWidth: 1.70611,
    id: "path7",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1564 15.5427L62.5236 30.0936C62.3167 30.7433 61.6356 31.1157 60.977 30.9393V30.9393C60.3113 30.7609 59.9074 30.0863 60.0646 29.4153L63.855 13.2318",
    stroke: "#522B2A",
    strokeWidth: 1.70611,
    id: "path8",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2054 15.4324L43.8085 29.8267C44.0641 30.626 44.9023 31.0837 45.7129 30.8665V30.8665C46.5218 30.6498 47.0188 29.837 46.8432 29.0182L43.3871 12.9015",
    stroke: "#522B2A",
    strokeWidth: 1.70611,
    id: "path9",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1084 20.2678L67.3392 29.5118C67.0234 30.1239 67.2441 30.8762 67.8406 31.2206V31.2206C68.435 31.5638 69.1941 31.3815 69.5678 30.8058L73.9791 24.0111",
    stroke: "#522B2A",
    strokeWidth: 1.70611,
    id: "path10",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6714 24.346L36.8522 30.8043C37.2252 31.3807 37.9845 31.5635 38.5791 31.2203V31.2203C39.1752 30.8761 39.3958 30.1243 39.0802 29.5126L34.7115 21.0447",
    stroke: "#522B2A",
    strokeWidth: 1.70611,
    id: "path11",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0081 41.407C59.8317 41.2668 60.5006 41.3486 61.3774 41.407",
    stroke: "#522B2A",
    strokeWidth: 2.60881,
    strokeLinecap: "round",
    id: "path12",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2258 41.407C46.4022 41.2668 45.7333 41.3486 44.8565 41.407",
    stroke: "#522B2A",
    strokeWidth: 2.60881,
    strokeLinecap: "round",
    id: "path13",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.603 48.8048L52.1738 45.9249C52.5655 45.2069 53.6006 45.2191 53.9752 45.9462L55.4698 48.8476C55.8098 49.5074 55.5752 50.3178 54.9355 50.6941L54.267 51.0874C53.5406 51.5147 52.6423 51.5257 51.9056 51.1165L51.1517 50.6977C50.48 50.3245 50.235 49.4794 50.603 48.8048Z",
    fill: "#522B2A",
    id: "path14",
    style: {
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.9993,
    y: 52.627,
    width: 8.14315,
    height: 2.64102,
    rx: 1.27959,
    stroke: "#522B2A",
    strokeWidth: 1.27959,
    id: "rect14",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0847 47.565C63.0847 49.0844 61.1108 50.3161 59.464 50.3161C57.8172 50.3161 56.4822 49.0844 56.4822 47.565C56.4822 46.0457 57.8172 44.814 59.464 44.814C61.1108 44.814 63.0847 46.0457 63.0847 47.565Z",
    fill: "#F8F8F8",
    id: "path15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.283 47.343V47.9102",
    stroke: "#522B2A",
    strokeWidth: 1.75516,
    strokeLinecap: "round",
    id: "path16",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0789 47.343V47.9102",
    stroke: "#522B2A",
    strokeWidth: 1.75516,
    strokeLinecap: "round",
    id: "path17",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.98 52.8469V55.2679",
    stroke: "#522B2A",
    strokeWidth: 0.853057,
    id: "path18",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1809 52.8469V55.2679",
    stroke: "#522B2A",
    strokeWidth: 0.853057,
    id: "path19",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1616 52.8469V55.2679",
    stroke: "#522B2A",
    strokeWidth: 0.853057,
    id: "path20",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.8445,
    cy: 36.9221,
    r: 0.959689,
    fill: "#522B2A",
    id: "circle20",
    style: {
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.7365,
    cy: 36.9221,
    r: 0.959689,
    fill: "#522B2A",
    id: "circle21",
    style: {
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.33425,
    height: 4.76747,
    rx: 1.66713,
    transform: "matrix(-0.290075 0.957004 0.957004 0.290075 30.8616 63.3613)",
    fill: "#F8F8F8",
    stroke: "#522B2A",
    strokeWidth: 1.81868,
    id: "rect21",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2385 67.1998V68.1595H48.2788C44.4738 68.1595 41.8343 67.3071 39.467 66.5427L39.4498 66.5371L39.7447 65.6239L39.4498 66.5371L39.2571 66.4749C36.9111 65.7182 34.7462 65.0493 31.4042 65.0493C29.3048 65.0493 28.3668 65.4937 27.8832 65.9197C27.3721 66.37 26.9083 67.2007 26.6528 68.8977L26.6487 68.925L26.643 68.952C26.5682 69.3083 26.5093 69.5064 26.4636 69.6482C26.4567 69.6694 26.4529 69.6811 26.4498 69.6907C26.4467 69.7002 26.4442 69.7078 26.44 69.7208L26.4366 69.7318C26.434 69.7711 26.4328 69.8694 26.4412 70.154C26.4454 70.2917 26.4509 70.4543 26.4579 70.6567C26.4619 70.7731 26.4663 70.9026 26.4712 71.0481C26.4854 71.0813 26.4955 71.1101 26.5024 71.1314C26.5099 71.1545 26.5155 71.1747 26.5196 71.1906C26.5238 71.2067 26.527 71.2211 26.5295 71.233C26.5345 71.2564 26.5379 71.2765 26.5402 71.2913C26.5448 71.3203 26.5476 71.3461 26.5495 71.3644C26.5532 71.4015 26.5558 71.4406 26.5578 71.4771C26.5599 71.5155 26.5618 71.5596 26.5637 71.6096C26.5797 72.0488 26.5962 72.467 26.6123 72.8762C26.6231 73.1517 26.6338 73.4232 26.6441 73.6942C26.8468 73.2336 27.1837 72.8353 27.6224 72.5581C28.4599 72.0288 29.5272 72.0288 30.3647 72.5581C31.109 73.0284 31.5603 73.8474 31.5603 74.7279V78.3069C31.5603 79.7404 31.0613 81.0443 30.0854 82.0037C29.1278 82.945 27.8488 83.4136 26.5829 83.4136C25.3169 83.4136 24.0379 82.945 23.0803 82.0037C22.1044 81.0443 21.6054 79.7404 21.6054 78.3069C21.6054 76.188 21.5489 74.7543 21.484 73.1072C21.4738 72.8495 21.4635 72.5865 21.4531 72.3149C21.4408 72.2873 21.4318 72.2634 21.4254 72.2453C21.4153 72.2167 21.408 72.1919 21.403 72.1733C21.3979 72.1544 21.394 72.1377 21.3911 72.1243C21.3854 72.0982 21.3817 72.0761 21.3793 72.0607C21.3747 72.0303 21.3719 72.0038 21.3702 71.9861C21.3668 71.95 21.3646 71.9122 21.3629 71.8778C21.3611 71.8414 21.3595 71.7993 21.358 71.7516C21.3477 71.4249 21.338 71.1454 21.3297 70.904C21.304 70.1615 21.2908 69.7807 21.3118 69.5035C21.3291 69.2753 21.3678 69.1034 21.4103 68.9231C21.4153 68.9016 21.4206 68.8795 21.426 68.8566C21.464 68.6967 21.5116 68.4959 21.5746 68.1818C21.9033 66.018 22.6356 63.8867 24.3936 62.3381C26.186 60.7592 28.6039 60.1678 31.4042 60.1678C35.6154 60.1678 38.4323 61.0538 40.9081 61.8524L41.0298 61.8916C43.3772 62.6491 45.3375 63.278 48.2788 63.278H49.2385V64.2377V67.1998Z",
    fill: "#522B2A",
    stroke: "#522B2A",
    strokeWidth: 1.91938,
    id: "path21",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1,
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4595 67.9576L32.6051 67.0418C32.7395 66.1965 32.2663 65.3719 31.4687 65.0615L27.4813 63.5094L23.8655 61.6767C23.4677 61.475 23.0097 61.4266 22.5785 61.5406L19.164 62.4432C18.5226 62.6127 18.0245 63.118 17.8641 63.7617L16.0482 71.0482C16.0035 71.2275 15.9864 71.4125 15.9975 71.597L16.284 76.3698C16.3199 76.9669 16.647 77.5081 17.1589 77.8174L20.5273 79.8526C20.7302 79.9752 20.9551 80.057 21.1894 80.0933L23.6891 80.4805L26.4399 80.9067C27.523 81.0744 28.537 80.3325 28.7048 79.2494C28.8726 78.1664 28.1306 77.1524 27.0475 76.9846L28.0306 77.1369C29.1137 77.3047 30.1277 76.5627 30.2954 75.4797C30.4632 74.3966 29.7213 73.3827 28.6382 73.2149L28.961 73.2649C30.044 73.4327 31.058 72.6907 31.2258 71.6076C31.3936 70.5246 29.9265 69.3983 28.8435 69.2305L30.385 69.4693C31.3748 69.6226 32.3022 68.9468 32.4595 67.9576Z",
    fill: "#F8F8F8",
    id: "path22"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.6051 67.0418L33.5032 67.1846L32.6051 67.0418ZM32.4595 67.9576L31.5614 67.8148L32.4595 67.9576ZM25.6511 67.8157C25.1548 67.7389 24.6902 68.0789 24.6133 68.5752C24.5364 69.0715 24.8764 69.5361 25.3727 69.613L25.6511 67.8157ZM22.5785 61.5406L22.3461 60.6614L22.3461 60.6614L22.5785 61.5406ZM19.164 62.4432L18.9316 61.564L18.9316 61.564L19.164 62.4432ZM17.1589 77.8174L17.6292 77.0391L17.1589 77.8174ZM20.5273 79.8526L20.9976 79.0743L20.5273 79.8526ZM25.0435 71.7378C24.5472 71.6609 24.0826 72.0009 24.0057 72.4972C23.9288 72.9935 24.2688 73.4582 24.7651 73.535L25.0435 71.7378ZM24.4359 75.6598C23.9396 75.583 23.475 75.923 23.3981 76.4192C23.3212 76.9155 23.6612 77.3802 24.1575 77.4571L24.4359 75.6598ZM23.6891 80.4805L23.8283 79.5819L23.8283 79.5819L23.6891 80.4805ZM21.1894 80.0933L21.0502 80.9919L21.0502 80.9919L21.1894 80.0933ZM17.8641 63.7617L18.7464 63.9816L17.8641 63.7617ZM16.0482 71.0482L16.9306 71.2681L16.0482 71.0482ZM15.9975 71.597L15.0898 71.6515L15.9975 71.597ZM16.284 76.3698L17.1917 76.3153L16.284 76.3698ZM23.8655 61.6767L23.4544 62.4878L23.4544 62.4878L23.8655 61.6767ZM27.4813 63.5094L27.0702 64.3205L27.1099 64.3406L27.1515 64.3568L27.4813 63.5094ZM31.4687 65.0615L31.1388 65.9089L31.1388 65.9089L31.4687 65.0615ZM31.707 66.899L31.5614 67.8148L33.3576 68.1004L33.5032 67.1846L31.707 66.899ZM30.5242 68.5707L28.9827 68.3319L28.7043 70.1291L30.2457 70.3679L30.5242 68.5707ZM28.9827 68.3319L25.6511 67.8157L25.3727 69.613L28.7043 70.1291L28.9827 68.3319ZM22.3461 60.6614L18.9316 61.564L19.3964 63.3223L22.8109 62.4197L22.3461 60.6614ZM16.6887 78.5957L20.0571 80.6309L20.9976 79.0743L17.6292 77.0391L16.6887 78.5957ZM29.1002 72.3662L28.7774 72.3162L28.499 74.1135L28.8218 74.1635L29.1002 72.3662ZM28.7774 72.3162L25.0435 71.7378L24.7651 73.535L28.499 74.1135L28.7774 72.3162ZM30.3272 71.4684C30.2363 72.0552 29.6869 72.4571 29.1002 72.3662L28.8218 74.1635C30.4011 74.4082 31.8797 73.3262 32.1244 71.7469L30.3272 71.4684ZM28.7043 70.1291C29.04 70.1811 29.5186 70.4088 29.8916 70.7483C30.2903 71.1112 30.341 71.3794 30.3272 71.4684L32.1244 71.7469C32.2784 70.7528 31.6795 69.9164 31.1158 69.4033C30.5265 68.867 29.7301 68.4477 28.9827 68.3319L28.7043 70.1291ZM28.1698 76.2383L27.1868 76.086L26.9083 77.8832L27.8914 78.0355L28.1698 76.2383ZM27.1868 76.086L24.4359 75.6598L24.1575 77.4571L26.9083 77.8832L27.1868 76.086ZM29.3968 75.3405C29.3059 75.9272 28.7566 76.3292 28.1698 76.2383L27.8914 78.0355C29.4707 78.2802 30.9494 77.1982 31.1941 75.6189L29.3968 75.3405ZM28.499 74.1135C29.0858 74.2044 29.4877 74.7537 29.3968 75.3405L31.1941 75.6189C31.4387 74.0396 30.3568 72.5609 28.7774 72.3162L28.499 74.1135ZM27.8061 79.1102C27.7152 79.697 27.1659 80.0989 26.5792 80.008L26.3007 81.8053C27.8801 82.05 29.3587 80.968 29.6034 79.3887L27.8061 79.1102ZM26.9083 77.8832C27.4951 77.9741 27.897 78.5235 27.8061 79.1102L29.6034 79.3887C29.8481 77.8093 28.7661 76.3307 27.1868 76.086L26.9083 77.8832ZM26.5792 80.008L23.8283 79.5819L23.5499 81.3791L26.3007 81.8053L26.5792 80.008ZM21.0502 80.9919L23.5499 81.3791L23.8283 79.5819L21.3286 79.1946L21.0502 80.9919ZM16.9817 63.5418L15.1659 70.8283L16.9306 71.2681L18.7464 63.9816L16.9817 63.5418ZM15.0898 71.6515L15.3763 76.4243L17.1917 76.3153L16.9052 71.5425L15.0898 71.6515ZM23.4544 62.4878L27.0702 64.3205L27.8924 62.6983L24.2766 60.8656L23.4544 62.4878ZM27.1515 64.3568L31.1388 65.9089L31.7985 64.214L27.8112 62.662L27.1515 64.3568ZM15.1659 70.8283C15.0988 71.0972 15.0732 71.3748 15.0898 71.6515L16.9052 71.5425C16.8997 71.4503 16.9082 71.3577 16.9306 71.2681L15.1659 70.8283ZM20.0571 80.6309C20.3614 80.8148 20.6988 80.9374 21.0502 80.9919L21.3286 79.1946C21.2115 79.1765 21.099 79.1356 20.9976 79.0743L20.0571 80.6309ZM17.6292 77.0391C17.3732 76.8845 17.2097 76.6138 17.1917 76.3153L15.3763 76.4243C15.4301 77.3199 15.9208 78.1318 16.6887 78.5957L17.6292 77.0391ZM18.9316 61.564C17.9696 61.8183 17.2223 62.5763 16.9817 63.5418L18.7464 63.9816C18.8266 63.6597 19.0757 63.4071 19.3964 63.3223L18.9316 61.564ZM31.5614 67.8148C31.4828 68.3094 31.0191 68.6473 30.5242 68.5707L30.2457 70.3679C31.7304 70.5979 33.1217 69.5842 33.3576 68.1004L31.5614 67.8148ZM33.5032 67.1846C33.7047 65.9167 32.995 64.6798 31.7985 64.214L31.1388 65.9089C31.5376 66.0641 31.7742 66.4764 31.707 66.899L33.5032 67.1846ZM22.8109 62.4197C23.0265 62.3627 23.2555 62.3869 23.4544 62.4878L24.2766 60.8656C23.6799 60.5631 22.9929 60.4905 22.3461 60.6614L22.8109 62.4197Z",
    fill: "#522B2A",
    id: "path23",
    style: {
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.293,
    y: 63.3613,
    width: 3.33425,
    height: 4.76747,
    rx: 1.66713,
    transform: "rotate(73.1375 75.293 63.3613)",
    fill: "#A89595",
    stroke: "#522B2A",
    strokeWidth: 1.81868,
    id: "rect23",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1,
      fill: "#f8f8f8",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.916 67.1998V68.1595H57.8757C61.6808 68.1595 64.3203 67.3071 66.6876 66.5427L66.7047 66.5371L66.4098 65.6239L66.7047 66.5371L66.8975 66.4749C69.2435 65.7182 71.4083 65.0493 74.7503 65.0493C76.8498 65.0493 77.7877 65.4937 78.2713 65.9197C78.7824 66.37 79.2462 67.2007 79.5017 68.8977L79.5058 68.925L79.5115 68.952C79.5863 69.3083 79.6452 69.5064 79.691 69.6482C79.6978 69.6694 79.7016 69.6811 79.7048 69.6907C79.7079 69.7002 79.7104 69.7078 79.7145 69.7208L79.718 69.7318C79.7205 69.7711 79.7218 69.8694 79.7133 70.154C79.7092 70.2917 79.7036 70.4543 79.6967 70.6567C79.6927 70.7731 79.6882 70.9026 79.6834 71.0481C79.6691 71.0813 79.659 71.1101 79.6521 71.1314C79.6446 71.1545 79.639 71.1747 79.6349 71.1906C79.6308 71.2067 79.6275 71.2211 79.625 71.233C79.62 71.2564 79.6166 71.2765 79.6143 71.2913C79.6098 71.3203 79.6069 71.3461 79.6051 71.3644C79.6014 71.4015 79.5988 71.4406 79.5968 71.4771C79.5947 71.5155 79.5927 71.5596 79.5909 71.6096C79.5748 72.0488 79.5584 72.467 79.5423 72.8762C79.5314 73.1517 79.5207 73.4232 79.5104 73.6942C79.3077 73.2336 78.9708 72.8353 78.5322 72.5581C77.6947 72.0288 76.6273 72.0288 75.7898 72.5581C75.0455 73.0284 74.5942 73.8474 74.5942 74.7279V78.3069C74.5942 79.7404 75.0932 81.0443 76.0691 82.0037C77.0267 82.945 78.3057 83.4136 79.5717 83.4136C80.8376 83.4136 82.1166 82.945 83.0742 82.0037C84.0501 81.0443 84.5491 79.7404 84.5491 78.3069C84.5491 76.188 84.6056 74.7543 84.6706 73.1072C84.6807 72.8495 84.6911 72.5865 84.7015 72.3149C84.7137 72.2873 84.7227 72.2634 84.7291 72.2453C84.7393 72.2167 84.7465 72.1919 84.7515 72.1733C84.7567 72.1544 84.7605 72.1377 84.7634 72.1243C84.7691 72.0982 84.7728 72.0761 84.7752 72.0607C84.7799 72.0303 84.7826 72.0038 84.7843 71.9861C84.7877 71.95 84.79 71.9122 84.7917 71.8778C84.7935 71.8414 84.7951 71.7993 84.7966 71.7516C84.8068 71.4249 84.8165 71.1454 84.8249 70.904C84.8506 70.1615 84.8638 69.7807 84.8428 69.5035C84.8255 69.2753 84.7868 69.1034 84.7443 68.9231C84.7392 68.9016 84.734 68.8795 84.7285 68.8566C84.6906 68.6967 84.6429 68.4959 84.5799 68.1818C84.2513 66.018 83.5189 63.8867 81.7609 62.3381C79.9685 60.7592 77.5506 60.1678 74.7503 60.1678C70.5392 60.1678 67.7222 61.0538 65.2465 61.8524L65.1248 61.8916C62.7773 62.6491 60.817 63.278 57.8757 63.278H56.916V64.2377V67.1998Z",
    fill: "#522B2A",
    stroke: "#522B2A",
    strokeWidth: 1.91938,
    id: "path24",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1,
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0007 67.9576L73.8551 67.0418C73.7207 66.1965 74.1939 65.3719 74.9915 65.0615L78.9789 63.5094L82.5947 61.6767C82.9925 61.475 83.4505 61.4266 83.8817 61.5406L87.2962 62.4432C87.9376 62.6127 88.4357 63.118 88.5961 63.7617L90.412 71.0482C90.4567 71.2275 90.4738 71.4125 90.4627 71.597L90.1762 76.3698C90.1403 76.9669 89.8132 77.5081 89.3013 77.8174L85.9329 79.8526C85.73 79.9752 85.5051 80.057 85.2708 80.0933L82.7711 80.4805L80.0203 80.9067C78.9372 81.0744 77.9232 80.3325 77.7554 79.2494C77.5877 78.1664 78.3296 77.1524 79.4127 76.9846L78.4296 77.1369C77.3465 77.3047 76.3325 76.5627 76.1648 75.4797C75.997 74.3966 76.7389 73.3827 77.822 73.2149L77.4992 73.2649C76.4162 73.4327 75.4022 72.6907 75.2344 71.6076C75.0666 70.5246 76.5337 69.3983 77.6167 69.2305L76.0753 69.4693C75.0854 69.6226 74.158 68.9468 74.0007 67.9576Z",
    fill: "#F8F8F8",
    id: "path25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.8551 67.0418L72.957 67.1846L73.8551 67.0418ZM74.0007 67.9576L74.8988 67.8148L74.0007 67.9576ZM80.8091 67.8157C81.3054 67.7389 81.77 68.0789 81.8469 68.5752C81.9238 69.0715 81.5838 69.5361 81.0875 69.613L80.8091 67.8157ZM83.8817 61.5406L84.1141 60.6614L84.1141 60.6614L83.8817 61.5406ZM87.2962 62.4432L87.5286 61.564L87.5286 61.564L87.2962 62.4432ZM89.3013 77.8174L88.831 77.0391L89.3013 77.8174ZM85.9329 79.8526L85.4626 79.0743L85.9329 79.8526ZM81.4167 71.7378C81.913 71.6609 82.3776 72.0009 82.4545 72.4972C82.5314 72.9935 82.1914 73.4582 81.6951 73.535L81.4167 71.7378ZM82.0243 75.6598C82.5206 75.583 82.9852 75.923 83.0621 76.4193C83.139 76.9155 82.799 77.3802 82.3027 77.4571L82.0243 75.6598ZM82.7711 80.4805L82.6319 79.5819L82.6319 79.5819L82.7711 80.4805ZM85.2708 80.0933L85.41 80.9919L85.41 80.9919L85.2708 80.0933ZM88.5961 63.7617L87.7138 63.9816L88.5961 63.7617ZM90.412 71.0482L89.5296 71.2681L90.412 71.0482ZM90.4627 71.597L91.3704 71.6515L90.4627 71.597ZM90.1762 76.3698L89.2685 76.3153L90.1762 76.3698ZM82.5947 61.6767L83.0058 62.4878L83.0058 62.4878L82.5947 61.6767ZM78.9789 63.5094L79.39 64.3205L79.3503 64.3406L79.3087 64.3568L78.9789 63.5094ZM74.9915 65.0615L75.3214 65.9089L75.3214 65.9089L74.9915 65.0615ZM74.7532 66.899L74.8988 67.8148L73.1026 68.1004L72.957 67.1846L74.7532 66.899ZM75.936 68.5707L77.4775 68.3319L77.7559 70.1291L76.2145 70.3679L75.936 68.5707ZM77.4775 68.3319L80.8091 67.8157L81.0875 69.613L77.7559 70.1291L77.4775 68.3319ZM84.1141 60.6614L87.5286 61.564L87.0638 63.3223L83.6493 62.4197L84.1141 60.6614ZM89.7715 78.5957L86.4031 80.6309L85.4626 79.0743L88.831 77.0391L89.7715 78.5957ZM77.36 72.3662L77.6828 72.3162L77.9612 74.1135L77.6385 74.1635L77.36 72.3662ZM77.6828 72.3162L81.4167 71.7378L81.6951 73.535L77.9612 74.1135L77.6828 72.3162ZM76.133 71.4684C76.2239 72.0552 76.7733 72.4571 77.36 72.3662L77.6385 74.1635C76.0591 74.4082 74.5805 73.3262 74.3358 71.7469L76.133 71.4684ZM77.7559 70.1291C77.4202 70.1811 76.9417 70.4088 76.5686 70.7483C76.1699 71.1112 76.1193 71.3794 76.133 71.4684L74.3358 71.7469C74.1818 70.7528 74.7807 69.9164 75.3444 69.4033C75.9337 68.867 76.7301 68.4477 77.4775 68.3319L77.7559 70.1291ZM78.2904 76.2383L79.2734 76.086L79.5519 77.8832L78.5688 78.0355L78.2904 76.2383ZM79.2734 76.086L82.0243 75.6598L82.3027 77.4571L79.5519 77.8832L79.2734 76.086ZM77.0634 75.3405C77.1543 75.9272 77.7036 76.3292 78.2904 76.2383L78.5688 78.0355C76.9895 78.2802 75.5108 77.1982 75.2661 75.6189L77.0634 75.3405ZM77.9612 74.1135C77.3745 74.2044 76.9725 74.7537 77.0634 75.3405L75.2661 75.6189C75.0215 74.0396 76.1034 72.5609 77.6828 72.3162L77.9612 74.1135ZM78.6541 79.1102C78.745 79.697 79.2943 80.0989 79.881 80.008L80.1595 81.8053C78.5801 82.05 77.1015 80.968 76.8568 79.3887L78.6541 79.1102ZM79.5519 77.8832C78.9651 77.9741 78.5632 78.5235 78.6541 79.1102L76.8568 79.3887C76.6121 77.8093 77.6941 76.3307 79.2734 76.086L79.5519 77.8832ZM79.881 80.008L82.6319 79.5819L82.9103 81.3791L80.1595 81.8053L79.881 80.008ZM85.41 80.9919L82.9103 81.3791L82.6319 79.5819L85.1316 79.1946L85.41 80.9919ZM89.4785 63.5418L91.2944 70.8283L89.5296 71.2681L87.7138 63.9816L89.4785 63.5418ZM91.3704 71.6515L91.0839 76.4243L89.2685 76.3153L89.555 71.5425L91.3704 71.6515ZM83.0058 62.4878L79.39 64.3205L78.5678 62.6983L82.1836 60.8656L83.0058 62.4878ZM79.3087 64.3568L75.3214 65.9089L74.6617 64.214L78.649 62.662L79.3087 64.3568ZM91.2944 70.8283C91.3614 71.0972 91.387 71.3748 91.3704 71.6515L89.555 71.5425C89.5605 71.4503 89.552 71.3577 89.5296 71.2681L91.2944 70.8283ZM86.4031 80.6309C86.0988 80.8148 85.7614 80.9374 85.41 80.9919L85.1316 79.1946C85.2487 79.1765 85.3612 79.1356 85.4626 79.0743L86.4031 80.6309ZM88.831 77.0391C89.087 76.8845 89.2506 76.6138 89.2685 76.3153L91.0839 76.4243C91.0301 77.3199 90.5394 78.1318 89.7715 78.5957L88.831 77.0391ZM87.5286 61.564C88.4906 61.8183 89.2379 62.5763 89.4785 63.5418L87.7138 63.9816C87.6336 63.6597 87.3845 63.4071 87.0638 63.3223L87.5286 61.564ZM74.8988 67.8148C74.9774 68.3094 75.4411 68.6473 75.936 68.5707L76.2145 70.3679C74.7298 70.5979 73.3385 69.5842 73.1026 68.1004L74.8988 67.8148ZM72.957 67.1846C72.7555 65.9167 73.4653 64.6798 74.6617 64.214L75.3214 65.9089C74.9226 66.0641 74.686 66.4764 74.7532 66.899L72.957 67.1846ZM83.6493 62.4197C83.4337 62.3627 83.2047 62.3869 83.0058 62.4878L82.1836 60.8656C82.7803 60.5631 83.4673 60.4905 84.1141 60.6614L83.6493 62.4197Z",
    fill: "#522B2A",
    id: "path26",
    style: {
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8289 41.5071L39.3217 49.6111",
    stroke: "#522B2A",
    strokeWidth: 2.13448,
    strokeLinecap: "round",
    id: "path27",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7522 41.5071L67.2593 49.6111",
    stroke: "#522B2A",
    strokeWidth: 2.13448,
    strokeLinecap: "round",
    id: "path28",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5208 5.95386L71.8128 8.3997C71.8326 8.56483 71.7675 8.72875 71.6399 8.83539L68.6986 11.2932M98.5754 23.1423L93.7564 25.8108C93.6121 25.8908 93.4372 25.893 93.2909 25.8167L88.4574 23.2977C88.2776 23.204 88.0587 23.2302 87.9061 23.3638L80.4786 29.8656M24.0249 5.95386L25.6001 11.0577C25.6458 11.2059 25.7588 11.3238 25.9048 11.3759L30.0447 12.8521M13.0828 1.62671L15.3465 7.26821C15.403 7.40908 15.5214 7.51595 15.6673 7.5578L20.766 9.02029C20.907 9.06076 21.0227 9.16213 21.0813 9.2967L23.1406 14.0265C23.1917 14.1437 23.2863 14.2365 23.4046 14.2851L28.8947 16.5417M4.18481 31.5562L9.2311 33.8778C9.31408 33.916 9.40606 33.9303 9.49672 33.9192L14.5556 33.2966L20.2425 32.0614C20.3736 32.033 20.5107 32.0593 20.6219 32.1343L24.9263 35.0371M6.22894 61.3655L7.93224 58.838C8.02365 58.7023 8.17651 58.621 8.34007 58.621H12.0201C12.1783 58.621 12.3268 58.5449 12.4192 58.4165L14.5106 55.5114C14.6202 55.3591 14.8069 55.2825 14.9918 55.3138L18.3151 55.8765M93.5252 29.3926L88.9789 27.6483C88.8035 27.581 88.6051 27.6194 88.4676 27.7474L84.026 31.8809M97.3295 53.2366H93.3147C93.1573 53.2366 93.0095 53.1614 92.9169 53.0341L89.7993 48.7469C89.7068 48.6196 89.5589 48.5443 89.4016 48.5443H84.026",
    stroke: "#522B2A",
    strokeWidth: 1.9672,
    strokeLinecap: "round",
    id: "path29",
    style: {
      stroke: "#d31f11",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3344 6.70574C86.0446 9.10705 77.7468 17.4432 77.9835 17.9131C78.179 18.3014 87.7481 11.0443 90.4225 9.0804C93.4239 6.87646 94.9339 5.22416 93.8349 3.97434C92.7359 2.72451 90.904 4.01086 88.3344 6.70574Z",
    fill: "#522B2A",
    id: "path30",
    style: {
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5116 47.1613C14.9024 46.4678 21.8679 45.8467 21.8571 45.329C21.8481 44.9014 13.7589 44.4774 11.4101 44.6636C8.77421 44.8726 6.71336 46.1453 7.6876 47.6947C8.54246 49.0542 9.97203 47.8979 12.5116 47.1613Z",
    fill: "#522B2A",
    id: "path31",
    style: {
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0449 19.1228C17.6993 20.929 25.9918 24.4754 25.7716 25.1058C25.5897 25.6266 15.5014 22.9124 12.6958 21.745C9.54724 20.4349 7.52911 18.0504 9.34314 16.5401C10.9349 15.2148 12.2255 17.2043 15.0449 19.1228Z",
    fill: "#522B2A",
    id: "path32",
    style: {
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9676 42.4936C16.1781 42.7619 20.4206 43.8616 20.5793 43.5837C20.7104 43.3541 16.7492 41.2651 15.6676 40.6588C14.4537 39.9784 13.6282 39.8254 13.2598 40.7911C12.8913 41.7567 13.609 42.1925 14.9676 42.4936Z",
    fill: "#522B2A",
    id: "path33",
    style: {
      fill: "#d31f11",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4338 16.3325C82.9861 17.0119 77.787 19.2297 77.8438 19.6386C77.8907 19.9763 83.5816 18.9904 85.1638 18.7578C86.9394 18.4968 87.903 18.003 87.5188 16.7265C87.1347 15.45 86.0585 15.5701 84.4338 16.3325Z",
    fill: "#522B2A",
    id: "path34",
    style: {
      fill: "#d31f11",
      fillOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs34"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_6462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.632,
    height: 85.3057,
    fill: "white",
    transform: "translate(0.183838)",
    id: "rect34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLts4);
export default __webpack_public_path__ + "static/media/Icon_LTS4.1be5e998ec147097d90f039cfdd6c974.svg";
export { ForwardRef as ReactComponent };